import { render, staticRenderFns } from "./WordImport.vue?vue&type=template&id=672f2edb&"
import script from "./WordImport.vue?vue&type=script&lang=js&"
export * from "./WordImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports